import { z } from 'zod';

export const productionDeclarationRecipientSchema = z.object({
  newRecipient: z
    .string()
    .trim()
    .pipe(z.email({ error: 'sendEmailModalInvalidRecipient' })),
});

export type ProductionDeclarationRecipientInput = z.input<
  typeof productionDeclarationRecipientSchema
>;

export type ProductionDeclarationRecipientValues = z.infer<
  typeof productionDeclarationRecipientSchema
>;
